import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import axios from "axios";
import { useEffect, useState } from "react";
import { eramanHost } from "~/Utils";
import { fetchAirportDropdownData, fetchBrandsData, fetchCategoriesData, fetchCategoriesDataById, fetchFoodBevarageDropdowData, fetchStoreDropdownData, fetchStoreDropdownDataByName, fetchStoreDropdownDataByStringId, fetchSubCategoriesData } from "./Products/FetchData";

export const getProductManagementDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  products: [
    {
      fieldName: "Images",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "multiFile",
      usedFileType: 'image/*',
      label: "Images",
      placeholder: "Enter Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 500,
        height: 500
      }
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_common_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_title",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_common_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_title",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Product Code",
      fieldValue: "productCode",
      className: "col-span-6",
      type: "text",
      name: "productCode",
      formType: "number",
      label: "Product Code",
      placeholder: "Enter Product Code",
      validation: { required: "Product Code is required" },
    },
    {
      fieldName: "Old Price",
      fieldValue: "oldPrice",
      className: "col-span-6",
      type: "text",
      name: "oldPrice",
      formType: "number",
      label: "Old Price",
      placeholder: "Enter Old Price",
      // validation: { required: "Old Price is required" },
    },
    {
      fieldName: "Price",
      fieldValue: "price",
      className: "col-span-6",
      type: "text",
      name: "price",
      formType: "number",
      label: "Price",
      placeholder: "Enter Price",
      validation: { required: "Price is required" },
    },
    {
      fieldName: "Discount Percentage",
      fieldValue: "productOffer",
      className: "col-span-6",
      type: "text",
      name: "productOffer",
      formType: "number",
      label: "Discount Percentage",
      placeholder: "Enter Discount Percentage",
      // validation: { required: "Discount Percentage is required" },
    },
    {
      fieldName: "Promotion Title (EN)",
      fieldValue: "field_promotion_title",
      className: "col-span-6",
      type: "text",
      name: "field_promotion_title",
      formType: "input",
      label: "Promotion Title (EN)",
      placeholder: "Enter Promotion Title (EN)",
      // validation: { required: "Promotion Title (EN) is required" },
    },
    {
      fieldName: "Promotion Title (MS)",
      fieldValue: "field_malay_promotion_title",
      className: "col-span-6",
      type: "text",
      name: "field_malay_promotion_title",
      formType: "input",
      label: "Promotion Title (MS)",
      placeholder: "Enter Promotion Title (MS)",
      // validation: { required: "Promotion Title (MS) is required" },
    },
    {
      fieldName: "Promotion Title (ZH)",
      fieldValue: "field_mandarin_promotion_title",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_promotion_title",
      formType: "input",
      label: "Promotion Title (ZH)",
      placeholder: "Enter Promotion Title (ZH)",
      // validation: { required: "Promotion Title (ZH) is required" },
    },
    {
      fieldName: "Airport",
      fieldValue: "field_airport_export",
      className: "col-span-6",
      type: "select",
      name: "field_airport_export",
      formType: "multiSelect",
      label: "Airport",
      placeholder: "Enter Airport",
      validation: { required: "Airport is required" },
    },
    {
      fieldName: "Store Location",
      fieldValue: "field_store_location_export",
      className: "col-span-6",
      type: "select",
      name: "field_store_location_export",
      formType: "multiSelect",
      label: "Store Location",
      placeholder: "Enter Store Location",
      loadOptions: fetchStoreDropdownDataByStringId,
      validation: { required: "Store Location is required" },
    },
    {
      fieldName: "Categories",
      fieldValue: "category",
      className: "col-span-6",
      type: "select",
      name: "category",
      formType: "select",
      label: "Categories",
      placeholder: "Enter Categories",
      validation: { required: "Categories is required" },
      // loadOptions: fetchCategoriesData,
    },
    {
      fieldName: "Sub Categories",
      fieldValue: "subCategory",
      className: "col-span-6",
      type: "select",
      name: "subCategory",
      formType: "select",
      label: "Sub Categories",
      placeholder: "Enter Sub Categories",
      // validation: { required: "Sub Categories is required" },
      // loadOptions: fetchSubCategoriesData,
    },
    {
      fieldName: "Brand",
      fieldValue: "brand",
      className: "col-span-6",
      type: "select",
      name: "brand",
      formType: "select",
      label: "Brand",
      placeholder: "Enter Brand",
      validation: { required: "Brand is required" },
      // loadOptions: fetchBrandsData,
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_common_malay_description",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_common_mandarin_descriptio",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_descriptio",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Terms & Conditions (EN)",
      fieldValue: "field_product_terms_conditions",
      className: "col-span-6",
      type: "text",
      name: "field_product_terms_conditions",
      formType: "richText",
      label: "Terms & Conditions (EN)",
      placeholder: "Enter Terms & Conditions (EN)",
      validation: { required: "Terms & Conditions (EN) is required" },
    },
    {
      fieldName: "Terms & Conditions (MS)",
      fieldValue: "field_malay_terms_and_conditions",
      className: "col-span-6",
      type: "text",
      name: "field_malay_terms_and_conditions",
      formType: "richText",
      label: "Terms & Conditions (MS)",
      placeholder: "Enter Terms & Conditions (MS)",
      // validation: { required: "Terms & Conditions (MS) is required" },
    },
    {
      fieldName: "Terms & Conditions (ZH)",
      fieldValue: "field_mandarin_terms_and_conditi",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_terms_and_conditi",
      formType: "richText",
      label: "Terms & Conditions (ZH)",
      placeholder: "Enter Terms & Conditions (ZH)",
      // validation: { required: "Terms & Conditions (ZH) is required" },
    },
    {
      fieldName: "Duty Free",
      fieldValue: "dutyFree",
      className: "col-span-12",
      type: "checkbox",
      name: "dutyFree",
      formType: "checkbox",
      label: "Duty Free",
      placeholder: "Enter Duty Free",
      // validation: { required: "Duty Free is required" },
    },
    {
      fieldName: "New",
      fieldValue: "field_new_arrival",
      className: "col-span-12",
      type: "checkbox",
      name: "field_new_arrival",
      formType: "checkbox",
      label: "New",
      placeholder: "Enter New",
      // validation: { required: "New is required" },
    },
    {
      fieldName: "Promotions",
      fieldValue: "field_promotions",
      className: "col-span-12",
      type: "checkbox",
      name: "field_promotions",
      formType: "checkbox",
      label: "Promotions",
      placeholder: "Enter Promotions",
      // validation: { required: "Promotions is required" },
    },
    {
      fieldName: "Best Seller",
      fieldValue: "field_best_seller",
      className: "col-span-12",
      type: "checkbox",
      name: "field_best_seller",
      formType: "checkbox",
      label: "Best Seller",
      placeholder: "Enter Best Seller",
      // validation: { required: "Best Seller is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "status",
      className: "col-span-12",
      type: "checkbox",
      name: "status",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  productBrand: [
    {
      fieldName: "Brand Image",
      fieldValue: "brandImage",
      className: "col-span-6",
      type: "image",
      name: "brandImage",
      formType: "file",
      label: "Brand Image",
      usedFileType: 'image/*',
      placeholder: "Select Brand Image",
      validation: { required: "Brand Image is required" },
      imageDimension: {
        width: 300,
        height: 300
      }
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_malay_title",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_title",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Categories",
      fieldValue: "field_parent_category",
      className: "col-span-6",
      type: "text",
      name: "field_parent_category",
      formType: "select",
      label: "Categories",
      placeholder: "Enter Categories",
      validation: { required: "Categories is required" },
      loadOptions: fetchCategoriesData,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  notificationSettings: [
    {
      fieldName: "Name",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Description",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "input",
      label: "Description",
      placeholder: "Enter Description",
      validation: { required: "Description is required" },
    },
    {
      fieldName: "Enabled",
      fieldValue: "enabled",
      className: "col-span-6",
      type: "text",
      name: "enabled",
      formType: "input",
      label: "Enabled",
      placeholder: "Enter Enabled",
      validation: { required: "Enabled is required" },
    },
    {
      fieldName: "Emails",
      fieldValue: "emails",
      className: "col-span-6",
      type: "text",
      name: "emails",
      formType: "input",
      label: "Emails",
      placeholder: "Enter Emails",
      validation: { required: "Emails is required" },
    },
  ],
  subCategories: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_malay_title",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_title",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Categories",
      fieldValue: "field_category_id",
      className: "col-span-6",
      type: "select",
      name: "field_category_id",
      formType: "select",
      label: "Categories",
      placeholder: "Enter Categories",
      validation: { required: "Categories is required" },
      loadOptions: fetchCategoriesData,
    },
    // {
    //   fieldName: "Order Sequence",
    //   fieldValue: "field_sub_order_seq",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_sub_order_seq",
    //   formType: "input",
    //   label: "Order Sequence",
    //   placeholder: "Enter Order Sequence",
    //   validation: {
    //     required: "Order Sequence is required",
    //     pattern: {
    //       value: /^[0-9]+$/, // Only numbers allowed
    //       message: "Please enter a valid number",
    //     },
    //   },
    // },
    {
      fieldName: "Published",
      fieldValue: "field_sub_published",
      className: "col-span-12",
      type: "checkbox",
      name: "field_sub_published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  categories: [
   {
    fieldName: "Name (EN)",
    fieldValue: "field_category_name",
    className: "col-span-6",
    type: "text",
    name: "field_category_name",
    formType: "input",
    label: "Name (EN)",
    placeholder: "Enter Name (EN)",
    validation: { required: "Name (EN) is required" },
  },
  {
    fieldName: "Name (MS)",
    fieldValue: "field_category_name_ms",
    className: "col-span-6",
    type: "text",
    name: "field_category_name_ms",
    formType: "input",
    label: "Name (MS)",
    placeholder: "Enter Name (MS)",
    // validation: { required: "Name (MS) is required" },
  },
  {
    fieldName: "Name (ZH)",
    fieldValue: "field_category_name_zh",
    className: "col-span-6",
    type: "text",
    name: "field_category_name_zh",
    formType: "input",
    label: "Name (ZH)",
    placeholder: "Enter Name (ZH)",
    // validation: { required: "Name (ZH) is required" },
  },
    // {
    //   fieldName: "Store Locations",
    //   fieldValue: "field_category_store_locations",
    //   className: "col-span-6",
    //   type: "textarea",
    //   name: "field_category_store_locations",
    //   formType: "textarea",
    //   label: "Store Locations",
    //   placeholder: "Enter Store Locations",
    //   validation: { required: "Store Locations is required" },
    // },
    // {
    //   fieldName: "Order Sequence",
    //   fieldValue: "field_category_order_sequence",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_category_order_sequence",
    //   formType: "input",
    //   label: "Order Sequence",
    //   placeholder: "Enter Order Sequence",
    //   validation: {
    //     required: "Order Sequence is required",
    //     pattern: {
    //       value: /^[0-9]+$/, // Only numbers allowed
    //       message: "Please enter a valid number",
    //     },
    //   },
    // },
    // {
    //   fieldName: "Published",
    //   fieldValue: "field_category_published",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "field_category_published",
    //   formType: "checkbox",
    //   label: "Published",
    //   placeholder: "Enter Published",
    //   // validation: { required: "Publish is required" },
    // }
  ],
  fAndBContent: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_common_image",
      className: "col-span-6",
      type: "image",
      name: "field_common_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
      imageDimension: {
        width: 1920,
        height: 740
      }
    },
  ],
  fAndBBrands: [
    {
      fieldName: "Image",
      fieldValue: "field_common_image",
      className: "col-span-6",
      type: "image",
      name: "field_common_image",
      formType: "file",
      label: "Image",
      usedFileType: 'image/*',
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 318,
        height: 230
      }
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_common_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_common_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  fAndBOutlet: [
    {
      fieldName: "Image",
      fieldValue: "field_common_image",
      className: "col-span-6",
      type: "image",
      name: "field_common_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Enter Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 600,
        height: 450
      }
    },
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    // {
    //   fieldName: "Title (MS)",
    //   fieldValue: "field_common_malay_title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_common_malay_title",
    //   formType: "input",
    //   label: "Title (MS)",
    //   placeholder: "Enter Title (MS)",
    //   // validation: { required: "Name (MS) is required" },
    // },
    // {
    //   fieldName: "Title (ZH)",
    //   fieldValue: "field_common_mandarin_title",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_common_mandarin_title",
    //   formType: "input",
    //   label: "Title (ZH)",
    //   placeholder: "Enter Title (ZH)",
    //   // validation: { required: "Name (ZH) is required" },
    // },
    {
      fieldName: "Airport",
      fieldValue: "field_food_bev_airport",
      className: "col-span-6",
      type: "text",
      name: "field_food_bev_airport",
      formType: "select",
      label: "Airport",
      placeholder: "Select Airport",
      validation: { required: "Airport is required" },
      loadOptions: fetchAirportDropdownData,
    },
    {
      fieldName: "Food and Beverages Type",
      fieldValue: "field_food_and_beverage_types",
      className: "col-span-6",
      type: "select",
      name: "field_food_and_beverage_types",
      formType: "select",
      label: "Food and Beverages Type",
      placeholder: "Select Food and Beverages Type",
      validation: { required: "Food and Beverages Type is required" },
      loadOptions: fetchFoodBevarageDropdowData,
    },
    {
      fieldName: "Store Locations",
      fieldValue: "field_store_location",
      className: "col-span-6",
      type: "select",
      name: "field_store_location",
      formType: "multiSelect",
      label: "Store Locations",
      placeholder: "Select Store Locations",
      loadOptions: fetchStoreDropdownData,
      validation: { required: "Store Locations are required" },
    },
    {
      fieldName: "Brands",
      fieldValue: "field_brands",
      className: "col-span-6",
      type: "select",
      name: "field_brands",
      formType: "multiSelect",
      label: "Brands",
      placeholder: "Select Brands",
      loadOptions: fetchBrandsData,
      // validation: { required: "Brands are required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_common_malay_description",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_common_mandarin_descriptio",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_descriptio",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  fAndBCategory: [
    {
      fieldName: "Sequence No.",
      fieldValue: "field_sequence_number",
      className: "col-span-6",
      type: "text",
      name: "field_sequence_number",
      formType: "number",
      label: "Sequence No.",
      placeholder: "Enter Sequence No.",
      validation: { required: "Sequence No. is required" },
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_food_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_food_malay_title",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_food_mandrian_title",
      className: "col-span-6",
      type: "text",
      name: "field_food_mandrian_title",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  eXpress: [
    {
      fieldName: "Images",
      fieldValue: "field_common_image",
      className: "col-span-6",
      type: "image",
      name: "field_common_image",
      formType: "multiFile",
      usedFileType: 'image/*',
      label: "Images",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      imageDimension: {
        width: 508,
        height: 364
      }
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_common_malay_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_title",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_common_mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_title",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Store Locations",
      fieldValue: "field_store_location",
      className: "col-span-6",
      type: "select",
      name: "field_store_location",
      formType: "multiSelect",
      label: "Store Locations",
      options: [],
      placeholder: "Select Store Locations",
      validation: { required: "Store Locations" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_common_malay_description",
      className: "col-span-6",
      type: "text",
      name: "field_common_malay_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_common_mandarin_descriptio",
      className: "col-span-6",
      type: "text",
      name: "field_common_mandarin_descriptio",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
  ],
};
